/* tslint:disable */
/* eslint-disable */
/**
 * medications
 * medications
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FindAllMedicationStockSignsOffsResponse } from './FindAllMedicationStockSignsOffsResponse';
import {
    FindAllMedicationStockSignsOffsResponseFromJSON,
    FindAllMedicationStockSignsOffsResponseFromJSONTyped,
    FindAllMedicationStockSignsOffsResponseToJSON,
} from './FindAllMedicationStockSignsOffsResponse';

/**
 * 
 * @export
 * @interface FindAllMedicationStockSignOffs200Response
 */
export interface FindAllMedicationStockSignOffs200Response {
    /**
     * 
     * @type {FindAllMedicationStockSignsOffsResponse}
     * @memberof FindAllMedicationStockSignOffs200Response
     */
    data?: FindAllMedicationStockSignsOffsResponse;
}

/**
 * Check if a given object implements the FindAllMedicationStockSignOffs200Response interface.
 */
export function instanceOfFindAllMedicationStockSignOffs200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllMedicationStockSignOffs200ResponseFromJSON(json: any): FindAllMedicationStockSignOffs200Response {
    return FindAllMedicationStockSignOffs200ResponseFromJSONTyped(json, false);
}

export function FindAllMedicationStockSignOffs200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllMedicationStockSignOffs200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : FindAllMedicationStockSignsOffsResponseFromJSON(json['data']),
    };
}

export function FindAllMedicationStockSignOffs200ResponseToJSON(value?: FindAllMedicationStockSignOffs200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': FindAllMedicationStockSignsOffsResponseToJSON(value.data),
    };
}

